export default __webpack_public_path__ + "df585cf25354f82273c724c1e5ce448bf4d350a669d50b5845dae20c3984a9d3.png";